module.exports = __webpack_public_path__ + "static/img/downloadappbg-1.ef1b4fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/download/downloadappbg-1.jpg
// module id = JomN
// module chunks = 7